exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn_2f9c603{width:150px;float:right;margin-left:20px}.box_1ba291b{min-height:125px;padding:10px;border:1px solid #f0f2f5}.box_1ba291b,.inputW_ba43f9d{width:400px!important}.input_bdeb1ce{width:60px!important;display:inline-block!important;border:1px solid #dcdfe6}.label_42448c2{color:#999!important}.item_6deffae{font-size:14px;margin-right:14px}.query_8399d95{border-top:1px solid #e3e3e3}.query_8399d95 h3{margin-top:20px}", ""]);

// exports
exports.locals = {
	"btn": "btn_2f9c603",
	"box": "box_1ba291b",
	"inputW": "inputW_ba43f9d",
	"input": "input_bdeb1ce",
	"label": "label_42448c2",
	"item": "item_6deffae",
	"query": "query_8399d95"
};